import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	day: {
		id: 'schools.resources.content.nav.day',
		defaultMessage: 'Day',
		description: 'The word "day" with a space',
	},

	previous: {
		id: 'schools.resources.content.nav.previous',
		defaultMessage: 'Previous',
		description: 'The word "previous"',
	},
	next: {
		id: 'schools.resources.content.nav.next',
		defaultMessage: 'Next',
		description: 'The word "next"',
	},
});
